import script from "./indexList.vue?vue&type=script&setup=true&lang=js"
export * from "./indexList.vue?vue&type=script&setup=true&lang=js"

import "./indexList.vue?vue&type=style&index=0&id=ba97121c&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba97121c"]])

export default __exports__